export interface IArchivingExportsSharedMetadata {
	dateFormatEntity?: Intl.DateTimeFormatOptions;
	dateFormatEntityExpires?: Intl.DateTimeFormatOptions;
	dateFormatFilter?: Intl.DateTimeFormatOptions;
	extendAllowedCount: number;
	extendMaxAvailableDays: number;
	warningStatusDaysLeftLimit: number;
}

export const ARCHIVING_EXPORTS_SHARED_METADATA: IArchivingExportsSharedMetadata = {
	dateFormatEntity: { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false },
	dateFormatEntityExpires: { day: '2-digit', month: 'long', year: 'numeric' },
	dateFormatFilter: { day: '2-digit', month: 'short', year: 'numeric' },
	extendAllowedCount: 3,
	extendMaxAvailableDays: 30,
	warningStatusDaysLeftLimit: 10
};
